var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFormsKiosk = function SvgFormsKiosk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5V3.5a2 2 0 00-2-2h-5a2 2 0 00-2 2v11a2 2 0 002 2h5a2 2 0 002-2v-2m-9 1h9m5-8.085l-1.417-1.412L9.35 8.736a1 1 0 00-.273.51l-.294 1.472 1.47-.295a.995.995 0 00.511-.273L15.5 5.415zm0 0L14.086 4l.707-.707A.999.999 0 0116.5 4a1 1 0 01-.293.707l-.707.708zm-5.303 2.474l1.414 1.414",
    stroke: "#5F6771",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFormsKiosk;